import { Icon } from "~/ui/Icon";
import type { TeacherClass } from "./classes";
import { isReadOnly } from "./classTeam";

export function ClassCard(props: {
  value: TeacherClass;
  onSelect: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onChangeCode: () => void;
  onTeam?: () => void;
}) {
  const readOnly = () => isReadOnly(props.value);
  return (
    <div class="card" style={{ cursor: "pointer" }} onClick={props.onSelect}>
      <div style={{ display: "flex", "justify-content": "space-between", "align-items": "flex-start", "margin-bottom": "12px" }}>
        <div>
          <h3>{props.value.name}</h3>
          <div style={{ "font-size": "0.8rem", color: "var(--text-muted)" }}>{props.value.school_year ?? ""}</div>
          {readOnly() && (
            <div style={{ "font-size": "0.82rem", "margin-top": "2px" }}>
              <span class="so-pill wait">Nur Ansicht</span> bearbeitet von {props.value.teacher_name}
            </div>
          )}
          {props.value.school_name && (
            <div style={{ "font-size": "0.82rem", color: "var(--text-muted)", "margin-top": "2px" }}>
              <Icon name="school" style={{ width: "13px", height: "13px" }} /> {props.value.school_name}
            </div>
          )}
        </div>
        <span class={`badge ${props.value.is_active ? "badge-success" : "badge-secondary"}`}>
          {props.value.is_active ? "Aktiv" : "Inaktiv"}
        </span>
      </div>
      <div style={{ display: "flex", gap: "16px", "margin-bottom": "16px" }}>
        <div style={{ "text-align": "center" }}>
          <div style={{ "font-size": "1.5rem", "font-weight": 800 }}>{props.value.student_count || 0}</div>
          <div style={{ "font-size": "0.75rem", color: "var(--text-muted)" }}>Schüler</div>
        </div>
      </div>
      <div style={{ position: "relative" }}>
        <div class="join-code-display" style={{ "font-size": "1.5rem", padding: "12px", "letter-spacing": "4px" }}>{props.value.join_code}</div>
        {!readOnly() && (
          <button
            type="button"
            style={{ position: "absolute", top: "50%", right: "8px", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", opacity: 0.5, padding: "4px" }}
            title="Klassencode ändern"
            onClick={(e) => { e.stopPropagation(); props.onChangeCode(); }}
          >
            <Icon name="pencil" style={{ width: "14px", height: "14px" }} />
          </button>
        )}
      </div>
      <div style={{ "margin-top": "12px", display: "flex", gap: "8px", "justify-content": "flex-end" }} onClick={(event) => event.stopPropagation()}>
        {props.onTeam && (
          <button class="btn btn-sm btn-secondary" type="button" onClick={props.onTeam}>
            <Icon name="school" style={{ width: "16px", height: "16px" }} /> Team
          </button>
        )}
        {!readOnly() && (
          <>
            <button class="btn btn-sm btn-secondary" type="button" onClick={props.onEdit}>
              <Icon name="pencil" style={{ width: "16px", height: "16px" }} /> Bearbeiten
            </button>
            <button class="btn btn-sm" type="button" style={{ background: "#fef2f2", color: "#dc2626", border: "1px solid #fecaca" }} onClick={props.onDelete}>
              <Icon name="trash" style={{ width: "16px", height: "16px" }} /> Löschen
            </button>
          </>
        )}
      </div>
    </div>
  );
}
